export enum BookingObjectViewModeEnum {
    Unset = 0,
    Host = 1,
    Premise = 2
}
